import axios from 'axios'
import { resourceTokenGenerate, resourcerFileUpload, getTemplateData, saveCanvasDpi, getCanvasDpi, getFontList, getUserResourcePages, saveFont, searchbyimage } from '@/api/design/resource'
import { designDownloadFile } from '@/api/affairs'

import { useUserStore } from '@/stores/user'
import { useSdkStore } from "@/stores/sdk";
import { useMiscStore } from "@/stores/misc";
import { ElMessage, ElMessageBox, ElSelect, ElOption, ElForm, ElFormItem, ElInput, ElInputNumber } from 'element-plus'
import { h, ref, defineComponent, render } from 'vue'

export const saveTemplate = async (data: any) => {
    const modifyPreview = async (pk: number) => {
        const res = await resourceTokenGenerate({ pk, ext: 'webp', filename: 'asfasfasfas' })
        if (res.data.code === 200 && data.preview) {
            console.log('res.data.data:', data.preview)
            const token = res.data.data.token
            const contentType = res.data.data.content_type
            await axios.put(token, data.preview, { headers: { 'Content-Type': contentType } })
        }
    }
    const modifyTemplate = async (pk: number) => {
        const res = await resourceTokenGenerate({ pk, ext: 'json', filename: 'asfasfasfas' })
        if (res.data.code === 200) {
            const token = res.data.data.token
            console.log('token:', token)
            const contentType = res.data.data.content_type
            await axios.put(token, data.templates, { headers: { 'Content-Type': contentType } })
        }
    }
    const urlParams = new URLSearchParams(window.location.search)
    if (!urlParams.get('id')) {
        return
    }
    const pk = urlParams.get('id') as string
    if (data.preview && data.templates) {
        await modifyPreview(data.pk || pk)
        await modifyTemplate(data.pk || pk)
    }




}

export const uploadfile = async (data: any) => {
    const userStore = useUserStore()
    const islogin = userStore.isLoggedIn
    console.log('islogin:', islogin)
    if (!islogin) {
        try {
            await ElMessageBox.confirm(
                '您还未登录，请先登录后再使用模板功能',
                '登录提示',
                {
                    confirmButtonText: '去登录',
                    cancelButtonText: '取消',
                    type: 'warning',
                    center: true
                }
            )
                // 用户点击"去登录"，跳转到登录页面
                ; (window as any).openGlobalLogin?.()
        } catch {
            // 用户点击"取消"或关闭对话框，不做任何操作
            return
        }
        return
    };
    const res = await resourcerFileUpload(data.file)
    if (res.data.code === 200) {
        return res.data.data
    }

}


export const loadTemplate = async () => {
    const urlParams = new URLSearchParams(window.location.search)
    const query = Object.fromEntries(urlParams.entries())
    console.log('URL query parameters:', query)
    const param = {
        pk: query.id,
        template: query.template,
        mode: query.mode
    }
    let result = await getTemplateData(param)

    const ossURL = result.data.data.data
    const miscStore = useMiscStore()
    miscStore.setOssURL(ossURL)
    const response = await axios.get(ossURL, { headers: { 'Cache-Control': 'no-cache' } })
    let getdpi = await getCanvasDpi({ canvas_id: response.data[0].id, template_id: query.id })
    const sdkStore = useSdkStore();
    const sdk = sdkStore.getSdk()
    const dpiVal = getdpi?.data?.data?.dpi
    console.log('dpiVal:', sdk)
    sdk.designOpt.setDpi(dpiVal)
    currentCanvasId = response.data[0].id
    currentTemplateId = query.id
    return result.data.data
}


let currentCanvasId: number | null = null
let currentTemplateId: any = null
export const onDpiChange = async (dpi: number) => {
    if (currentCanvasId && currentTemplateId) {
        await saveCanvasDpi({ canvas_id: currentCanvasId, template_id: currentTemplateId, dpi })
    }
}

export const setfontList = async () => {
    let page = 1
    const size = 100
    const all: any[] = []
    while (true) {
        const res = await getFontList({ page, size })
        const items = res?.data?.data?.items || []
        const base = 'https://shanyin-design.oss-cn-hangzhou.aliyuncs.com'
        const normalize = (s: any) => {
            const v = String(s || '')
            if (!v) return v
            return v.startsWith('http') ? v : `${base}${v.startsWith('/') ? '' : '/'}${v}`
        }
        for (const it of items) {
            if (it) {
                if ('url' in it) (it as any).url = normalize((it as any).url)
                if ('preview' in it) (it as any).preview = normalize((it as any).preview)
            }
            all.push(it)
        }
        if (items.length < size) break
        page += 1
    }
    const seen = new Set<string>()
    const unique: any[] = []
    for (const it of all) {
        const k = String((it as any).fontname || '').trim().toLowerCase()
        if (!k) {
            unique.push(it)
            continue
        }
        if (seen.has(k)) continue
        seen.add(k)
        unique.push(it)
    }
    const sdkStore = useSdkStore();
    const sdk = sdkStore.getSdk()
    sdk.designOpt.setFontConfig({ fontList: unique })
}
export const uploadFont = async (uploadListFn) => {
    const userStore = useUserStore()
    const islogin = userStore.isLoggedIn
    if (!islogin) {
        try {
            await ElMessageBox.confirm(
                '您还未登录，请先登录后再使用模板功能',
                '登录提示',
                {
                    confirmButtonText: '去登录',
                    cancelButtonText: '取消',
                    type: 'warning',
                    center: true
                }
            )
                // 用户点击"去登录"，跳转到登录页面
                ; (window as any).openGlobalLogin?.()
        } catch {
            // 用户点击"取消"或关闭对话框，不做任何操作
            return
        }
        return
    };
    const input = document.createElement('input') as HTMLInputElement
    input.type = 'file'
    input.accept = '.ttf,.otf,.woff,.woff2'
    input.multiple = true
    input.onchange = async () => {
        const files = input.files ? Array.from(input.files) : []
        console.log('files', files)
        await resourcerFileUpload(files[0])
        const fileName = files[0].name.replace(/\.[^/.]+$/, '')
        await addfont(fileName)
        await setfontList()
        uploadListFn()

    }
    input.click()
}
const addfont = async (filename: any) => {
    const res = await getUserResourcePages({ page: 1, size: 10 })
    let list = res.data.data.items
    const fontItem = list.find(item => item.name === filename)
    if (fontItem) {
        const base = 'https://shanyin-design.oss-cn-hangzhou.aliyuncs.com'
        const normalize = (s: any) => {
            const v = String(s || '')
            if (!v) return v
            return v.startsWith('http') ? v : `${base}${v.startsWith('/') ? '' : '/'}${v}`
        }
        const fontUrl = fontItem.file
        console.log('fontUrl:', fontUrl)
        const previewUrl = normalize(fontItem.preview)
        const fontName = fontItem.name || fontUrl
        let params = {
            "url": fontUrl,
            "preview": previewUrl,
            "fontname": fontName,
            "font_family": fontName,
            "resource_id": fontItem.id
        }
        await saveFont(params)
    }


}
export const AIsearchimg = async (e) => {
    const userStore = useUserStore()
    const islogin = userStore.isLoggedIn
    console.log('islogin:', islogin)
    if (!islogin) {
        try {
            await ElMessageBox.confirm(
                '您还未登录，请先登录后再使用模板功能',
                '登录提示',
                {
                    confirmButtonText: '去登录',
                    cancelButtonText: '取消',
                    type: 'warning',
                    center: true
                }
            )
                // 用户点击"去登录"，跳转到登录页面
                ; (window as any).openGlobalLogin?.()
        } catch {
            // 用户点击"取消"或关闭对话框，不做任何操作
            return
        }
        return
    };
    const sdkStore = useSdkStore();
    const sdk = sdkStore.getSdk()
    const activeObject = sdk.designOpt.getSelectedElement().activeObject
    console.log('activeObject:', activeObject)
    sdk.designOpt.showLoading(true)
    const res = await searchbyimage({
        image_url: activeObject?.src || activeObject?.originSrc,
        size: 30
    })
    const aiImgs = res?.data?.data?.items || []
    sdk.designOpt.showLoading(false)
    const anchor = e && (e.currentTarget || e.target) as HTMLElement | null
    const container = document.querySelector('#page') as HTMLElement | null
    const mount = document.createElement('div')
    if (container) {
        container.appendChild(mount)
    } else {
        document.body.appendChild(mount)
    }
    let offset = 0
    let lastLeft = 0
    let lastTop = 0
    let rafId = 0
    const close = () => {
        render(null, mount)
        if (mount.parentNode) (mount.parentNode as HTMLElement).removeChild(mount)
        window.removeEventListener('scroll', relayout, true)
        window.removeEventListener('resize', relayout)
        if (container) container.removeEventListener('scroll', relayout)
        if (rafId) cancelAnimationFrame(rafId)
        window.removeEventListener('click', onClickOutside, true)
    }
    const getPreviewSrc = (it: any) => {
        const s = (it && (it.previewUrl || it.preview || it.url || it.image || it.image_url || it.cover_image)) || ''
        const proxyImageNodes = `https://platform-design.aishanyin.com/api/design/material/proxy-image?url=${encodeURIComponent(s)}&content_type=${it.contentType}`
        return String(proxyImageNodes)
    }
    const useImage = (src: string) => {
        sdk.designOpt.replaceImage(src)
    }
    const renderPopup = (layoutOnly: boolean = false) => {
        const rectEl = anchor ? anchor.getBoundingClientRect() : (container ? container.getBoundingClientRect() : { left: 0, top: 0 })
        const left = rectEl.left - 60
        const top = rectEl.top - 140
        const len = aiImgs.length
        const batch = len ? [aiImgs[(offset) % len], aiImgs[(offset + 1) % len], aiImgs[(offset + 2) % len]] : []
        let imageNodes: any[] = []

        if (batch.length) {
            imageNodes = batch.map((it: any) => {
                const src = getPreviewSrc(it)
                return h('div', { style: 'flex:1;height:80px;border-radius:8px;overflow:hidden;background:#f5f5f5;cursor:pointer;position:relative;', onClick: () => useImage(src) }, [
                    h('img', { src, style: 'width:100%;object-fit:cover;object-position:center;display:block;position:absolute;top:50%;transform:translateY(-50%);' })
                ])
            })
        } else {
            imageNodes = [h('div', { style: 'position:absolute;left:12px;top:40px;font-size:12px;color:#666;' }, '暂无图片')]
        }
        if (layoutOnly && left === lastLeft && top === lastTop) return
        lastLeft = left
        lastTop = top
        const vnode = h('div', {
            style: `position:fixed;left:${left}px;top:${top + 10}px;width:270px;height:167px;background:#fff;border-radius:12px;box-shadow:0 8px 24px rgba(0,0,0,.18);z-index:9999;`
        }, [
            h('div', { style: 'position:absolute;left:12px;top:10px;font-size:12px;color:#111;font-weight:600;' }, 'AI搜图结果'),
            h('div', { style: 'position:absolute;right:8px;top:8px;width:24px;height:24px;border-radius:6px;display:flex;align-items:center;justify-content:center;cursor:pointer;color:#666;', onClick: close }, '×'),
            h('div', { style: 'position:absolute;left:12px;right:12px;top:40px;height:80px;display:flex;gap:8px;' }, imageNodes),
            h('div', { style: 'position:absolute;right:12px;bottom:10px;font-size:12px;color:#2a66ff;cursor:pointer;', onClick: () => { if (len) { offset = (offset + 3) % len; renderPopup(false) } } }, '换一批')
        ])
        render(vnode, mount)
    }
    const relayout = () => renderPopup(true)
    window.addEventListener('scroll', relayout, true)
    window.addEventListener('resize', relayout)
    if (container) container.addEventListener('scroll', relayout)
    const step = () => { renderPopup(true); rafId = requestAnimationFrame(step) }
    rafId = requestAnimationFrame(step)
    const onClickOutside = (evt: MouseEvent) => { const t = evt.target as Node | null; if (t && !mount.contains(t)) close() }
    setTimeout(() => window.addEventListener('click', onClickOutside, true), 0)
}
export const downloadFile = async (arr) => {
    let res = await designDownloadFile(arr)
    return res
}
